<template>

  <table class="box box-primary process-table list table table-striped">
    <thead>
      <tr>
        <th v-if="checkable"></th>
        <th v-for="col in cols">{{ col.name }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(d, di) in tableData" :id="d.id" :class="getEntryClassName(d)">
        <td v-if="checkable">
          <input type="checkbox" @change="setTableCheckbox(d)" v-model="d._selected"></input>
        </td >
        <td v-for="c in cols" :class="getClass(c)">
          <a v-if="c.clickable" @click="cellClicked({entry: d, field: c.prop})">
            {{ c.type == 'eur' ? d[c.prop].toLocaleString('de', {minimumFractionDigits: 2}) : d[c.prop] }}
          </a>
          <span v-else-if="c.type == 'actions'" class="table-actions">
            <lte-button v-for="a in c.actions" :type="a.type" :key=`${d.id}${a.name}` :label="a.label" @click="$emit(a.name, d)" />
          </span>
          <span v-else-if="c.type == 'eur'" class="text-right">
            {{ formatNumber(d[c.prop]) }}
          </span>
          <span v-else-if="c.type == 'value'" class="text-right">
            {{ d[c.prop] }}
          </span>
          <span v-else-if="c.type == 'date'" class="text-right">
            {{ fdate(d[c.prop]) }}
          </span>
          <span v-else>
            {{ d[c.prop] }}
          </span>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="anySums">
      <tr>
        <td v-if="checkable"></th>
        <td v-for="col in cols" :class="getClass(col)">{{ getColSum(col) }}</td>
      </tr>
    </tfoot>
  </table>


</template>
<script>
import defaultTools from '../../mixins/defaultTools'
export default {
  mixins: [defaultTools],
  props: {
    cols: { type: Array, default: []},
    tableData: { type: Array, default: () => {
      return []
    }},
    striped: { type: Boolean, default: false },
    checkable: { type: Boolean, default: false },
    allCheckedFallback: { type: Boolean, default: false }
  },
  computed: {
    anySums(){
      var s = false
      this.cols.forEach(c => {
        if (c.sum){
          s = true
        }
      })
      return s
    }
  },
  watch: {
    tableData: {
      handler(){
        this.tableData.forEach(e => {
          if (this.allCheckedFallback == true){
            this.tableData.forEach(d => {
              d._selected = true
            })
          }
        })
      }, deep: true
    }


  },
  methods: {
    getEntryClassName(d){
      if (this.checkable != false){
        if (d._selected == true){
          return 'row-selected'
        }else{
          return 'row-idgaf'
        }

      }
    },
    getClass(c){

      var css = []

      if (c.type == 'eur' || c.type == 'std' || c.type == "hrs" || c.type == 'date' || c.type == 'value'){
        css.push("text-right")
      }
      if (c.clickable){
        css.push("clickable")
      }

      return css.join(" ")
    },
    getColSum(col){
      if ( col.sum ){
        var sum = 0
        this.tableData.forEach(d => {
          sum = sum + d[col.prop]
        })
        return sum.toLocaleString('de', {minimumFractionDigits: 2})
      }


    },
    setTableCheckbox(d){

      this.$emit('row-toggled', d)

      var rowIdsSelected = []

      this.tableData.forEach(td => {
        if (td._selected){
          rowIdsSelected.push(td.id)
        }
      })
      this.$emit('row-status-selected', rowIdsSelected)
    },
    entryClicked(d){
      this.$emit('entry-clicked', d)
    },
    cellClicked(d){
      this.$emit('cell-clicked', d)
    }
  }
}
</script>